import {createStore} from 'redux';
import RootReducer from './Reducers/RootReducer/index.js';

const Store = createStore(RootReducer);

export default Store;